export const NAME = `funnel-proposals`;
export const PER_PAGE = 7;
